/**
 * デプロイ直後、古いタブが差し替え済みのファイルを読みに行って失敗するエラーの文言かを判定する。
 * 該当するときだけ、ルーターが1回だけ再読み込みする（router.onError）。
 *
 * 以前からの3種（JSの動的import失敗）に、Viteが出す CSS のプリロード失敗を加えた。
 * 範囲を広げすぎると、関係のないエラーで再読み込みしてしまうので、文言は限っている。
 */
const STALE_CHUNK_MESSAGES = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS'
]

export function isStaleChunkErrorMessage(message) {
  const msg = String(message || '')
  return STALE_CHUNK_MESSAGES.some((m) => msg.includes(m))
}
